<template>
  <div class="layout">
    <div class="navigation">
      <navigation />
    </div>
    <div class="main_left">
      <div class="top">
        <div class="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item
              v-for="(item, index) in breadcrumbList"
              :key="index"
            >
              <span v-if="index !== breadcrumbList.length - 1" style="color: #848282;">{{ item }}</span>
              <span
                v-if="index == breadcrumbList.length - 1"
                style="color: #383b40"
                >{{ item }}</span
              ></el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
        <div class="user">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              <i class="el-icon-user" style="font-size: 24px"></i>
              {{ user }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="exit">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- 内容部分 -->
      <div class="member-right-navbar">
        <app-main></app-main>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from "./navigation.vue";
import AppMain from "./AppMain.vue";
export default {
  components: {
    navigation,
    AppMain,
  },
  data() {
    return {
      breadcrumbList: [],
      user: "",
    };
  },
  created() {
    // console.log(
    //   this.$router.history.current.meta.title,
    //   "this.$router.history.current.meta.title"
    // );
    this.breadcrumbList = this.$router.history.current.meta.title?this.$router.history.current.meta.title.split(","):'';
    // if(this.$router.path=='/layout/newCompetition'){
    //   debugger
    // }
    this.user = localStorage.getItem("nickName_b");
  },
  watch: {
    $route(e) {
      this.breadcrumbList = e.meta.title.split(",");
      if (e.path == "/layout/newCompetition") {
        if (e.query.opt == "edit") {
          this.breadcrumbList[this.breadcrumbList.length - 1] = "编辑比赛";
        } else if (e.query.opt == "add") {
          this.breadcrumbList[this.breadcrumbList.length - 1] = "添加比赛";
        } else if (e.query.opt == "look") {
          this.breadcrumbList[this.breadcrumbList.length - 1] = "查看比赛";
        }
      }
    },
  },
  methods: {
    exit() {
      this.$confirm("确定退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          setTimeout(() => {
            localStorage.removeItem("username_b");
            localStorage.removeItem("nickName_b");
            localStorage.removeItem("token_b");
            localStorage.removeItem("value");
            localStorage.removeItem("index");
            localStorage.removeItem("progressNow");
            localStorage.removeItem("userType_b");
            this.$router.push("/login_b");
            this.$message({
              type: "success",
              duration: 1000,
              showClose: true,
              message: "退出成功!",
            });
          }, 300);
        })
        .catch(() => {
          this.$message({
            type: "info",
            duration: 1000,
            showClose: true,
            message: "已取消退出",
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dropdown-link {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: bold;
  color: #848282;
}
/deep/.el-breadcrumb__inner {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #383b40 !important;
}
/deep/.el-button--primary {
  background-color: #145afe !important;
}
.layout {
  display: flex;
  justify-content: space-around;
}
.navigation {
  // width: 10%;
  width: 200px;
}
.main_left {
  // width: 90%;
  flex: 1;
  overflow: hidden;
  .top {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #ddd;
    .user {
      display: inline-block;
      float: right;
      margin-right: 16px;
      /deep/.el-dropdown {
        color: #171717;
        font-weight: bold;
        font-size: 18px;
      }
    }
  }
  .breadcrumb {
    // background-color: #f8f8f8;
    // height: 50px;
    display: inline-block;
    // float: left;
    line-height: 50px;
    padding-left: 20px;
    /deep/.el-breadcrumb {
      display: inline-block;
    }
  }
  .member-right-navbar {
    height: calc(100vh - 50px);
  }
}
</style>
